import script from "./DefaultBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultBreadcrumb.vue?vue&type=style&index=0&id=03202eca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03202eca"]])

export default __exports__